import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { saveUserProfile } from '../utils/userPreferences';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id found in URL');
          navigate('/login');
          return;
        }

        const sessionId = sessionIdMatch[1];

        // Exchange session_id for session data
        const response = await fetch(
          'https://demobackend.emergentagent.com/auth/v1/env/oauth/session-data',
          {
            headers: {
              'X-Session-ID': sessionId
            }
          }
        );

        if (!response.ok) {
          throw new Error('Failed to get session data');
        }

        const userData = await response.json();
        // userData: { id, email, name, picture, session_token }

        // Send session data to our backend to create/update user and set cookie
        const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
        const backendResponse = await fetch(`${BACKEND_URL}/api/auth/google-callback`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'include',
          body: JSON.stringify(userData)
        });

        if (!backendResponse.ok) {
          throw new Error('Backend authentication failed');
        }

        const backendData = await backendResponse.json();

        // Save user profile to local storage
        saveUserProfile({
          name: userData.name || '',
          email: userData.email || '',
          mobile: '',
          age: '',
          picture: userData.picture || ''
        });

        // Navigate to home with user data
        navigate('/', { 
          replace: true,
          state: { user: backendData.user }
        });

      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login');
      }
    };

    processAuth();
  }, [navigate, location]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-700 mx-auto"></div>
        <p className="mt-4 text-gray-600">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
